import { api } from '@/lib/axios';
import type { Page } from '@/services/chantiers';

export type TypeDocumentEntreprise =
  | 'RC' | 'NIF' | 'NIS' | 'AI' | 'EXTRAIT_ROLE' | 'ATTESTATION_CNAS' | 'ATTESTATION_CASNOS'
  | 'CASIER_JUDICIAIRE_GERANT' | 'STATUTS' | 'BILAN' | 'ATTESTATION_BANCAIRE'
  | 'QUALIFICATION_CLASSIFICATION' | 'ATTESTATION_BONNE_EXECUTION' | 'LISTE_MATERIEL' | 'AUTRE';

export const TYPE_DOC_ORDRE: TypeDocumentEntreprise[] = [
  'RC', 'NIF', 'NIS', 'AI', 'EXTRAIT_ROLE', 'ATTESTATION_CNAS', 'ATTESTATION_CASNOS',
  'CASIER_JUDICIAIRE_GERANT', 'STATUTS', 'BILAN', 'ATTESTATION_BANCAIRE',
  'QUALIFICATION_CLASSIFICATION', 'ATTESTATION_BONNE_EXECUTION', 'LISTE_MATERIEL', 'AUTRE',
];

export const TYPE_DOC_LABEL: Record<TypeDocumentEntreprise, string> = {
  RC: 'Registre de commerce (RC)',
  NIF: "N° d'identification fiscale (NIF)",
  NIS: "N° d'identification statistique (NIS)",
  AI: "Article d'imposition (AI)",
  EXTRAIT_ROLE: 'Extrait de rôle (apuré)',
  ATTESTATION_CNAS: 'Attestation CNAS',
  ATTESTATION_CASNOS: 'Attestation CASNOS',
  CASIER_JUDICIAIRE_GERANT: 'Casier judiciaire (gérant)',
  STATUTS: 'Statuts de la société',
  BILAN: 'Bilan comptable',
  ATTESTATION_BANCAIRE: 'Attestation bancaire',
  QUALIFICATION_CLASSIFICATION: 'Qualification & classification',
  ATTESTATION_BONNE_EXECUTION: 'Attestation de bonne exécution',
  LISTE_MATERIEL: 'Liste du matériel',
  AUTRE: 'Autre document',
};

export type StatutExpiration = 'SANS' | 'A_JOUR' | 'EXPIRE_BIENTOT' | 'EXPIRE';

export interface DocumentEntrepriseDTO {
  id: string;
  type: TypeDocumentEntreprise;
  libelle: string;
  fichier_url: string | null;
  date_emission: string | null;
  date_expiration: string | null;
  exercice: number | null;
  is_active: boolean;
  notes: string | null;
  is_archived: boolean;
  statut_expiration: StatutExpiration;
  jours_restants: number | null;
}

export interface DocumentEntrepriseInput {
  type: TypeDocumentEntreprise;
  libelle: string;
  fichier_url?: string | null;
  date_emission?: string | null;
  date_expiration?: string | null;
  exercice?: number | null;
  is_active?: boolean;
  notes?: string | null;
  is_archived?: boolean;
}

export interface AlertesDocuments {
  expires: DocumentEntrepriseDTO[];
  expirent_bientot: DocumentEntrepriseDTO[];
}

export async function listDocuments(params?: { type?: TypeDocumentEntreprise; q?: string; archives?: boolean; size?: number }): Promise<Page<DocumentEntrepriseDTO>> {
  const { data } = await api.get<Page<DocumentEntrepriseDTO>>('/documents-entreprise', { params: { size: 200, ...params } });
  return data;
}

export async function getAlertesDocuments(): Promise<AlertesDocuments> {
  const { data } = await api.get<AlertesDocuments>('/documents-entreprise/alertes');
  return data;
}

export async function createDocument(input: DocumentEntrepriseInput): Promise<DocumentEntrepriseDTO> {
  const { data } = await api.post<DocumentEntrepriseDTO>('/documents-entreprise', input);
  return data;
}

export async function updateDocument(id: string, input: Partial<DocumentEntrepriseInput>): Promise<DocumentEntrepriseDTO> {
  const { data } = await api.put<DocumentEntrepriseDTO>(`/documents-entreprise/${id}`, input);
  return data;
}

export async function deleteDocument(id: string): Promise<void> {
  await api.delete(`/documents-entreprise/${id}`);
}
